import type { ActionEffects, WitnessEffects, WorldState } from '../types/demo'

export function getWorldState(action: ActionEffects, witness: WitnessEffects): WorldState {
  return {
    sidePathVisible: Boolean(action.sideRouteVisible || witness.witnessSideRouteVisible),
    signalLine: Boolean(action.smallSignalSent),
    pantherFocusClear: Boolean(action.grassObserved || action.pantherObservedWithCare),
    pantherTrust: Boolean(action.pantherObservedWithCare),
    amaraAtSide: Boolean(action.sideRouteVisible),
    allyJoined: Boolean(witness.allyJoined),
    sentinelNearby: Boolean(witness.sentinelCalled),
    pathSign: Boolean(witness.witnessSideRouteVisible),
  }
}

export interface RippleCard {
  id: 'safety' | 'dignity' | 'connection' | 'accountability' | 'clarity'
  title: string
  lines: string[]
}

export function getRippleCards(action: ActionEffects, witness: WitnessEffects): RippleCard[] {
  const safety: string[] = []
  if (action.sideRouteVisible || witness.witnessSideRouteVisible) safety.push('A side path is easier to see.')
  if (witness.sentinelCalled) safety.push('Sentinel is nearby to help check.')
  if (safety.length === 0) safety.push('One clue is clearer. More support is still possible.')

  const connection: string[] = []
  if (action.smallSignalSent) connection.push('Monkey noticed a small signal.')
  if (witness.allyJoined) connection.push('Giraffe is not alone.')
  if (connection.length === 0) connection.push('No new connection was added in this route. You can still make room.')

  return [
    { id: 'safety', title: 'Safety', lines: safety },
    { id: 'dignity', title: 'Dignity', lines: ['Monkey is not asked to explain or stand in the center.'] },
    { id: 'connection', title: 'Connection', lines: connection },
    {
      id: 'accountability',
      title: 'Accountability',
      lines: ['The Meerkat echo is not resolved. Stopping its spread belongs to the next part of the story.'],
    },
    {
      id: 'clarity',
      title: 'Clarity',
      lines: ['Panther is watching grass. The hiss and the group story may be different.'],
    },
  ]
}
